module.exports = __webpack_public_path__ + "static/media/013_A_infopanel.40675334.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/013_A_infopanel.png
// module id = 576
// module chunks = 0